<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productMoldId" :primary-key="form.productMoldId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.productMoldId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <t-input cols="6" v-model="form.moldId"
                       label="Molde"
                       :options="moldOptions" :add-error="error.moldId" required select/>

              <t-input cols="3" v-model="form.cavities" submitted number label="Cavidade(s)" required/>

              <t-input cols="3" v-model="form.note" label="Observação"/>

            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>

        </b-row>

      </b-col>

    </t-form-list>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import MoldService from "@/services/modules/production/Mold.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProductMold',
  data() {
    return {
      path: "product/item-mold", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productMoldId", keyDelete: "productMoldId"},
        {key: "moldCodeLabel", label: "Molde", cols: "2"},
        {key: "name", label: "Descrição", cols: "3"},
        {key: "stockMoldLocation", label: "Localização", cols: "2"},
        {key: "cavities", label: "Cavidades", cols: "1"},
        {key: "note", label: "Obs.", cols: "2", align: "right"},
      ],
      form: {
        productId: this.foreignKey,
        productMoldId: 0,
        moldId: 0,
        cavities: 0,
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        moldId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      moldOptions:[],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await MoldService.selectList("grouped").then((list) => {
        this.moldOptions = list
      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productMoldId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
